// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__5pV4c","signatureButtonsRight":"ModalSign_signatureButtonsRight__2DTmD"};